import React, { Fragment, useState} from "react";
const Dream = () => {
  const [inputDream, setInputDream] = useState("");
  const [buttonDreamStatus, setButtonDream] = useState(true);
  const [status, setStatus] = useState(false);
  const [dreamStatus, setDreamStatus] = useState(false);
  const [waitStatus, setWaitStatus] = useState(false);
  const [seconds, setSeconds] = useState(3);
  const [ketqua, setketqua] = useState(false)
  const countdown = () => {
    window.timer = setInterval(function () {
      setSeconds(seconds => seconds - 1);
    }, 1000);
  }
  function getRandomNumberBetween(min,max){
    return Math.floor(Math.random()*(max-min+1)+min);
  }
  const showInputDream = () => {
    if (status === true) {
      return (
        <div>
          <form>
            <textarea
              className="form-control"
              style={{ marginTop: "19px" }}
              placeholder={"Nhập giấc mơ của bạn tại đây"}
              onChange={(e) => setInputDream(e.target.value)}
            />
          </form>
          <button
            className="btn btn-primary"
            type="button"
            style={{
              background: "var(--red)",
              borderStyle: "none",
              borderColor: "var(--danger)",
              borderTopColor: "rgb(255,",
              borderRightColor: "255,",
              borderBottomColor: "255)",
              borderLeftColor: "255,",
              borderRadius: "0px",
              marginTop: "16px",
              fontSize: "30px",
              fontFamily: "Alata, sans-serif",
            }}
            onClick={() => {
              setDreamStatus(!dreamStatus);
              setStatus(!status);
              setButtonDream(!buttonDreamStatus);
              setWaitStatus(!waitStatus);
              countdown();
            }}
          >
            Soi đề
          </button>
        </div>
      );
    }
  };
  
  const WaitDream = () => {
    
    if (waitStatus === true) {
      return (
        <h1
          style={{
            color: "var(--green)",
            fontSize: "26px",
            marginTop: "27px",
            fontFamily: "Alata, sans-serif",
          }}
        >
          Chờ trong giây lát...
          {seconds >= 0 ? seconds 
          : setWaitStatus(!waitStatus) + setketqua(!ketqua) + clearInterval(window.timer)}
        </h1>
      );
    }
  };
  const showDreamStatus = () => {
    if (dreamStatus === true) {
      return (
        <div className="mt-4">
          <h3>
            Giấc mơ của bạn là: <h3 style={{ color: "red" }}>{inputDream}</h3>
          </h3>
        </div>
      );
    }
  };

  const buttonDream = () => {
    if (buttonDreamStatus === true) {
      return (
        <button
          className="btn btn-primary"
          type="button"
          style={{
            color: "var(--light)",
            background: "rgb(20,0,255)",
            fontSize: "24px",
            borderRadius: "0px",
            borderStyle: "none",
            fontFamily: "Alata, sans-serif",
          }}
          onClick={() => setStatus(!status)}
        >
          Nhập vào giấc mơ của bạn
        </button>
      );
    }
  };
  const result = () => {
    if (ketqua === true){
      return (
        <div>
          <h1
            style={{
              marginTop: "17px",
              fontSize: "36px",
              fontFamily: "Alata, sans-serif",
            }}
          >
            Đề hôm nay sẽ về
          </h1>
          <h1
            style={{
              fontSize: "70px",
              color: "var(--orange)",
              fontFamily: "Alata, sans-serif",
            }}
          >
            {getRandomNumberBetween(10,99)}
          </h1>
        </div>
      );
    }
    
  };
  return (
    <Fragment>
      {buttonDream()}
      <div className="container">
        <div className="row">
          <div className="col">{showInputDream()}</div>
        </div>
      </div>

      {showDreamStatus()}
      {/* SOI DE */}
      {WaitDream()}
      {result()}
    </Fragment>
  );
};

export default Dream;
